// extracted by mini-css-extract-plugin
export default {"m":"Amount_m__04PbT","amount":"Amount_amount__Vmhe8","amountNumber":"Amount_amountNumber__kCJ5z","tip":"Amount_tip__aBDdz"};